import { render, staticRenderFns } from "./formMyHistoryTaskHt.vue?vue&type=template&id=31dea941&"
import script from "./formMyHistoryTaskHt.vue?vue&type=script&lang=js&"
export * from "./formMyHistoryTaskHt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports